import axios from "axios";
import dayjs from "../utils/dayjsConfig";
import { attachSentryResponseInterceptor } from "./sentryAxiosInterceptor";

//TYPES
import { AuthData, PositionsBalanceResponse } from "../types/types";
import { PositionGroups } from "../pages/ValuationPage/types";

//AXIOS INSTANCE

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_POSITION_BASE_URL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    "X-Client-Origin": "ALLARIA",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const localAuth = localStorage.getItem("allaria-auth");

    const parsedLocalAuth: AuthData | null =
      (localAuth && JSON.parse(localAuth)) ?? null;

    const token = parsedLocalAuth?.access_token;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
attachSentryResponseInterceptor(axiosInstance);

export const getAccountBalance = async ({
  accountNumber,
  date,
}: {
  accountNumber: string;
  date?: string;
}) => {
  const filterDate = date
    ? dayjs(date).format("YYYY-MM-DD")
    : dayjs().format("YYYY-MM-DD");

  const response = await axiosInstance.get(
    `/by-mas/positions?account-id=${accountNumber}&asset=BALANCES&date=${filterDate}&grouped-by=NONE&company=ALLARIA`
  );

  return response.data as PositionsBalanceResponse;
};

export const getAccountPositions = async ({
  accountNumber,
  date,
  asset,
  groupedBy = "NONE",
}: {
  accountNumber: string;
  date?: string;
  asset?: string;
  groupedBy?: "NONE" | "CURRENCY" | "INSTRUMENT";
}) => {
  const filterDate = date
    ? dayjs(date).format("YYYY-MM-DD")
    : dayjs().format("YYYY-MM-DD");

  let groupingParams = "";

  if (groupedBy === "CURRENCY") {
    groupingParams = "&group-by-sub-category-description=true";
  } else if (groupedBy === "INSTRUMENT") {
    groupingParams = "&group-by-sub-category-and-description=true";
  }

  const response = await axiosInstance.get<PositionGroups>(
    `/by-mas/positions?account-id=${accountNumber}${
      asset ? `&asset=${asset}` : ""
    }&date=${filterDate}&grouped-by=${groupedBy}${groupingParams}&company=ALLARIA`,
  );

  return response.data;
};
